(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-best-sellers"] && !Shopify.designMode) return;
  try {
    
  const normalizeProductPath = (value) => {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '');
    } catch {
      return value;
    }
  };

  const refreshBestSellers = () => {
    const relatedPaths = new Set(
      Array.from(document.querySelectorAll('product-recommendations a[href*="/products/"], [data-pb-color-related] a[href*="/products/"]'))
        .map((link) => normalizeProductPath(link.href))
    );

    document.querySelectorAll('[data-pb-best-sellers]').forEach((section) => {
      const limit = Number(section.dataset.limit) || 4;
      let visible = 0;

      section.querySelectorAll('.pb-merch-card').forEach((card) => {
        const isDuplicate = relatedPaths.has(normalizeProductPath(card.dataset.productPath));
        const shouldShow = !isDuplicate && visible < limit;
        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });
    });
  };

  refreshBestSellers();

  document.querySelectorAll('product-recommendations, [data-pb-color-related]').forEach((section) => {
    new MutationObserver(refreshBestSellers).observe(section, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-color-related"] && !Shopify.designMode) return;
  try {
    
  const pbColorFamilies = [
    ['wine red', 'burgundy', 'maroon', 'ruby', 'crimson', 'red'],
    ['navy blue', 'navy', 'royal blue', 'cobalt', 'teal', 'blue'],
    ['emerald green', 'emerald', 'forest green', 'olive', 'sage', 'mint', 'matcha', 'green'],
    ['hot pink', 'fuchsia', 'magenta', 'rose', 'blush', 'mauve', 'pink'],
    ['plum', 'violet', 'lavender', 'lilac', 'purple'],
    ['chocolate', 'mocha', 'camel', 'tan', 'brown'],
    ['champagne', 'cream', 'ivory', 'apricot', 'khaki', 'beige'],
    ['white', 'ivory', 'cream'],
    ['black'],
    ['mustard', 'ochre', 'gold', 'yellow'],
    ['terracotta', 'coral', 'rust', 'orange'],
    ['silver', 'grey', 'gray']
  ];

  const pbNormalize = (value) => String(value || '').trim().toLowerCase();
  const pbPath = (value) => {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '');
    } catch {
      return value;
    }
  };

  const pbFamilyFor = (color) => {
    const normalized = pbNormalize(color);
    return pbColorFamilies.find((family) => family.some((shade) => normalized.includes(shade))) || [normalized];
  };

  const pbPrice = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return String(value || '');
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency
    }).format(amount);
  };

  const pbCreateCard = (product) => {
    const article = document.createElement('article');
    article.className = 'pb-color-related__card';
    article.dataset.matchedColor = product.matched_color || '';

    const link = document.createElement('a');
    link.href = product.url;

    const media = document.createElement('div');
    media.className = 'pb-color-related__image';

    const imageUrl = product.featured_image?.url || product.image || '';
    if (imageUrl) {
      const image = document.createElement('img');
      const responsiveUrl = new URL(imageUrl, window.location.origin);
      responsiveUrl.searchParams.set('width', '640');
      image.src = responsiveUrl.href;
      image.srcset = [320, 480, 640, 960].map((width) => {
        const url = new URL(responsiveUrl);
        url.searchParams.set('width', String(width));
        return `${url.href} ${width}w`;
      }).join(', ');
      image.sizes = '(min-width: 990px) 24vw, 78vw';
      image.decoding = 'async';
      image.alt = product.featured_image?.alt || product.title || '';
      image.loading = 'lazy';
      media.append(image);
    }

    const title = document.createElement('h3');
    title.textContent = product.title || '';

    const price = document.createElement('p');
    price.textContent = pbPrice(product.price_min || product.price);

    link.append(media, title, price);
    article.append(link);
    return article;
  };

  const pbSearchProducts = async (section, query, signal) => {
    const base = section.dataset.searchUrl || '/search/suggest';
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': '10',
      'resources[options][unavailable_products]': 'hide'
    });
    const response = await fetch(`${base}.json?${params.toString()}`, { signal });
    if (!response.ok) return [];
    const data = await response.json();
    return data?.resources?.results?.products || [];
  };

  const pbMatchesFamily = (value, family) => {
    const normalized = pbNormalize(value);
    return family.some((shade) => normalized.includes(shade) || shade.includes(normalized));
  };

  const pbHydrateColorVariant = async (product, color, signal) => {
    const productPath = pbPath(product.url);
    const response = await fetch(`${productPath}.js`, { signal });
    if (!response.ok) return null;

    const details = await response.json();
    const colorOption = details.options?.find((option) => {
      const name = pbNormalize(option.name);
      return name.includes('color') || name.includes('colour');
    });
    if (!colorOption) return null;

    const family = pbFamilyFor(color);
    const optionKey = `option${colorOption.position}`;
    const available = details.variants?.filter((variant) => variant.available) || [];
    const exactColor = pbNormalize(color);

    const exactVariant = available.find((variant) => pbNormalize(variant[optionKey]) === exactColor);
    const familyVariant = available.find((variant) => pbMatchesFamily(variant[optionKey], family));
    const variant = exactVariant || familyVariant;
    const imageUrl = variant?.featured_image?.src || variant?.featured_image?.url;

    if (!variant || !imageUrl) return null;

    return {
      ...product,
      title: details.title || product.title,
      url: `${productPath}?variant=${variant.id}`,
      price_min: Number(variant.price) / 100,
      matched_color: variant[optionKey],
      featured_image: {
        url: imageUrl,
        alt: `${details.title || product.title} – ${variant[optionKey]}`
      }
    };
  };

  const pbLoadColorRelated = async (section, newColor) => {
    section.pbController?.abort();
    section.pbController = new AbortController();
    const signal = section.pbController.signal;
    const color = newColor || section.dataset.color;
    const track = section.querySelector('[data-pb-track]');
    const status = section.querySelector('[data-pb-status]');
    const colorLabel = section.querySelector('[data-pb-color-label]');
    if (colorLabel) colorLabel.textContent = color || '';
    section.querySelector('[data-pb-color-description]').hidden = !color;
    track.setAttribute('aria-busy', 'true');
    track.replaceChildren(...Array.from({ length: Number(section.dataset.limit) || 6 }, () => {
      const placeholder = document.createElement('div');
      placeholder.className = 'pb-color-related__skeleton';
      placeholder.setAttribute('aria-hidden', 'true');
      return placeholder;
    }));
    status.textContent = 'Finding dresses in similar colors…';
    const style = section.dataset.style || 'dress';
    const family = pbFamilyFor(color).filter(Boolean);
    const exact = pbNormalize(color);
    const terms = [];

    if (exact) terms.push(`${exact} ${style} dress`);
    family.forEach((shade) => terms.push(`${shade} ${style} dress`));
    if (exact) terms.push(`${exact} dress`);
    family.forEach((shade) => terms.push(`${shade} dress`));

    const uniqueTerms = [...new Set(terms)];
    const currentPath = pbPath(section.dataset.currentPath);
    const products = new Map();
    const hydratedProducts = new Map();
    const limit = Number(section.dataset.limit) || 6;

    try {
      for (const term of uniqueTerms) {
        if (products.size >= limit) break;
        const matches = await pbSearchProducts(section, term, signal);
        const candidates = matches.filter((item) => {
          const path = pbPath(item.url);
          return path && path !== currentPath && !products.has(path);
        });
        const hydrated = await Promise.all(
          candidates.map((item) => {
            const path = pbPath(item.url);
            if (!hydratedProducts.has(path)) hydratedProducts.set(path, pbHydrateColorVariant(item, color, signal));
            return hydratedProducts.get(path);
          })
        );
        hydrated.forEach((item) => {
          if (!item || products.size >= limit) return;
          products.set(pbPath(item.url), item);
        });
      }

      if (signal.aborted || !section.isConnected) return;
      const selected = [...products.values()].slice(0, limit);
      track.replaceChildren(...selected.map(pbCreateCard));

      if (selected.length) {
        status.textContent = `Showing ${selected.length} dresses in ${color || 'similar colors'}`;
      } else {
        status.textContent = 'No matching color recommendations are available right now.';
      }

      section.dispatchEvent(new CustomEvent('pb:related-updated', { bubbles: true }));
    } catch (error) {
      if (!signal.aborted && error.name !== 'AbortError') {
        track.replaceChildren();
        status.textContent = 'Related dresses are temporarily unavailable.';
      }
    } finally {
      if (!signal.aborted) track.removeAttribute('aria-busy');
    }
  };

  const pbRelatedObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const section = entry.target;
      section.pbVisible = true;
      pbRelatedObserver.unobserve(section);
      pbLoadColorRelated(section);
    });
  }, { rootMargin: '300px' }) : null;

  document.querySelectorAll('[data-pb-color-related]').forEach((section) => {
    if (pbRelatedObserver) pbRelatedObserver.observe(section);
    else {
      section.pbVisible = true;
      pbLoadColorRelated(section);
    }

    section.querySelector('[data-pb-prev]').addEventListener('click', () => {
      section.querySelector('[data-pb-track]').scrollBy({ left: -section.clientWidth * 0.8, behavior: 'smooth' });
    });

    section.querySelector('[data-pb-next]').addEventListener('click', () => {
      section.querySelector('[data-pb-track]').scrollBy({ left: section.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    const name = pbNormalize(target?.name);
    if (!name.includes('color') && !name.includes('colour')) return;
    document.querySelectorAll('[data-pb-color-related]').forEach((section) => {
      if (section.dataset.color === target.value) return;
      section.dataset.color = target.value;
      const label = section.querySelector('[data-pb-color-label]');
      if (label) label.textContent = target.value;
      if (section.pbVisible) pbLoadColorRelated(section, target.value);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pb-recently-viewed]').forEach((section) => {
    const currentNode = section.querySelector('[data-pb-current-product]');
    const grid = section.querySelector('[data-pb-recent-grid]');
    if (!currentNode || !grid) return;
    try {
      const current = JSON.parse(currentNode.textContent);
      const stored = JSON.parse(localStorage.getItem('pbRecentlyViewed') || '[]');
      const previous = stored.filter((item) => item && item.handle && item.handle !== current.handle);
      localStorage.setItem('pbRecentlyViewed', JSON.stringify([current, ...previous].slice(0, 12)));
      const limit = Number(section.dataset.limit || 4);
      previous.slice(0, limit).forEach((item) => {
        const card = document.createElement('a');
        card.className = 'pb-recent-card';
        card.href = item.url;
        const media = document.createElement('div');
        media.className = 'pb-recent-card__image';
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        media.appendChild(image);
        const title = document.createElement('h3');
        title.textContent = item.title;
        const price = document.createElement('p');
        price.textContent = item.price;
        card.append(media, title, price);
        grid.appendChild(card);
      });
      if (grid.children.length) section.hidden = false;
    } catch (error) {
      section.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
